import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { UserRole } from '../enums/user-role.enum';
import { WorkflowToken } from '../enums/workflow-token.enum';
import { AuthService } from '../services/auth.service';
import { SessionService } from '../services/session.service';

@Injectable()
export class LoginGuard implements CanActivate {
	constructor(private authService: AuthService, private sessionService: SessionService, private router: Router) {}

	/**
	 * Can current user activates the page
	 *
	 * @param route - Active rout
	 * @param state - Router state
	 * @param allowedRoles - Array with names of allowed roles, if set at least one is necessary
	 * @param allowedWorkflows - Array with name of allowed workflows, if set at least one is necessary
	 * @return
	 */
	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
		allowedRoles?: UserRole[],
		allowedWorkflows?: WorkflowToken[]
	): Observable<boolean> {
		// Get parameter
		const code = route.queryParams['code'];
		const idToken = route.queryParams['id_token'];
		const redirectUrl = route.data['guardRedirectUrl'];
		return this.guardHandling(code, idToken, redirectUrl);
	}

	/**
	 * Guard handling
	 */
	private guardHandling(code?: string, idToken?: string, redirectUrl?: string): Observable<boolean> {
		// Return Observable with the logged in status
		return new Observable<boolean>((subscriber) => {
			// Check parameter
			if (code && idToken) {
				this.authService.login(idToken, code, true).subscribe(() => {
					this.router.navigate(['/dashboard/welcome']);
					subscriber.next(true);
					subscriber.complete();
				});
			} else {
				// Check if logged in
				this.authService.loggedIn(true, true).subscribe((loggedIn) => {
					if (loggedIn) {
						this.router.navigate(['/dashboard/welcome']);
						subscriber.next(true);
						subscriber.complete();
					} else {
						if (redirectUrl) {
							this.router.navigate([redirectUrl]);
						} else {
							this.router.navigate(['/']);
						}
						subscriber.next(true);
						subscriber.complete();
					}
				});
			}
		});
	}
}
